import React from "react";
import {
  Grid,
  Table,
  Segment,
  Message,
  Button,
  Popup,
  Form, Input
} from "semantic-ui-react";
import { Helmet } from "react-helmet";
import moment from "moment";

const OrderDetails = ({ orderId, loading, details, onClickOfAddToSheet, popUp_style, handleIssueChange, button_copy}) => {
  // console.log("this is details", details.details.paymentDetails);
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: "90vh" }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  if (!orderId) {
    return (
      <Message
        icon="info"
        color="yellow"
        header="Not Found"
        content="Seems like the order Id is invalid or there is no record available"
      />
    );
  }

  return (
    <Grid centered padded style={{ marginTop: "0px", padding: "10vh" }}>
      <Helmet>
        <title>Orders Details</title>
      </Helmet>
      <Grid.Row>
        <Grid.Column width={2} textAlign="center"></Grid.Column>
        <Grid.Column width={4} textAlign="center">
          <h2
            style={{
              fontWeight: 400,
              border: "1px solid #555",
              textAlign: "center",
              color: "#555",
              padding: "0.5em",
            }}
          >
            Orders Details
          </h2>
          <h3 style={{ fontWeight: 400 }}>Vieweing Order Id : {orderId}</h3>
        </Grid.Column>
        <Grid.Column width={2} textAlign="left">
          <Popup
            trigger={
            <Button basic color="blue" fluid content="Add to sheet" class="btn_copy"/>
          }
            on="click"
            position="left bottom"
            style={popUp_style}
          >
            <Form>
              <Form.Field required>
                <label>Issue Type</label>
                <Input fluid icone defaultValue="Vending Failed" onChange={handleIssueChange}/>
              </Form.Field>
              <Button  
                  color="blue"
                  fluid
                  data-actiontype="onClickOfSearch"
                  onClick={onClickOfAddToSheet} 
                  
              >
                {button_copy ? "Copied" : "Copy"}
                </Button>
            </Form>
          </Popup>
        </Grid.Column>
      </Grid.Row>
      {details.details.loading ? (
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Segment style={{ height: "90vh" }} loading={orders.loading} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ) : null}
      <Grid.Row>
        {details.details &&
        details.details.order &&
        details.details.order.length ? (
          <React.Fragment>
            <h3 style={{ fontWeight: 400, textDecoration: "underline" }}>
              Order Details
            </h3>
            <Table celled striped fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Order Id</Table.HeaderCell>
                  <Table.HeaderCell>Mobile</Table.HeaderCell>
                  <Table.HeaderCell>Amount</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>VM Id</Table.HeaderCell>
                  <Table.HeaderCell>Payment Id</Table.HeaderCell>
                  <Table.HeaderCell>Source</Table.HeaderCell>
                  <Table.HeaderCell>Created On</Table.HeaderCell>
                  <Table.HeaderCell>Cashback</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {details.details.order.map((el) => (
                  <Table.Row key={el.orderId}>
                    <Table.Cell style={{ wordWrap: "break-word" }}>
                      {el.orderId}
                    </Table.Cell>
                    <Table.Cell>{el.orderMobile || "N/A"}</Table.Cell>
                    <Table.Cell>Rs. {el.orderAmount}</Table.Cell>
                    <Table.Cell>{el.orderStatus}</Table.Cell>
                    <Table.Cell>{el.orderVM}</Table.Cell>
                    <Table.Cell>{el.orderPaymentId}</Table.Cell>
                    <Table.Cell>
                      {el.orderSource === "vending"
                        ? "Kiosk App"
                        : "Consumer App"}
                    </Table.Cell>
                    <Table.Cell>
                      {/* {new Date(el.created_at).toLocaleString()} */}
                      {moment
                        .utc(el.orderCreatedAt)
                        .local()
                        .format("DD-MM-YYYY HH:mm:ss")}
                    </Table.Cell>
                    <Table.Cell>{el.orderCashback ? "Yes" : "No"}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </React.Fragment>
        ) : null}
        {details.details &&
        details.details.orderLineItems &&
        details.details.orderLineItems.length ? (
          <React.Fragment>
            <h3 style={{ fontWeight: 400, textDecoration: "underline" }}>
              Order Line Items
            </h3>

            <Table celled fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Variant Name</Table.HeaderCell>
                  <Table.HeaderCell>Product Code[MV Id]</Table.HeaderCell>
                  <Table.HeaderCell>Item Quantity</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>S/F/P Count</Table.HeaderCell>
                  <Table.HeaderCell>MRP</Table.HeaderCell>
                  <Table.HeaderCell>Offer Price</Table.HeaderCell>
                  <Table.HeaderCell>Slot Identifier</Table.HeaderCell>
                  <Table.HeaderCell>SKU Group Id</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {details.details &&
                  details.details.orderLineItems &&
                  details.details.orderLineItems.length &&
                  details.details.orderLineItems.map((el) => (
                    <Table.Row key={el.oliId}>
                      <Table.Cell>{el.oliProductName}</Table.Cell>
                      <Table.Cell>{el.oliProductId}</Table.Cell>
                      <Table.Cell>{el.oliQunatity}</Table.Cell>
                      <Table.Cell>{`${el.oliStatus}`}</Table.Cell>
                      <Table.Cell>{`${el.oliS || 0}/${el.oliF || 0}/${el.oliP ||
                        0}`}</Table.Cell>
                      <Table.Cell>Rs. {el.oliMRP}</Table.Cell>
                      <Table.Cell>Rs. {el.oliOfferPrice}</Table.Cell>
                      <Table.Cell>{el.oliSlotIndentifier}</Table.Cell>
                      <Table.Cell>{el.oliSKU}</Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </React.Fragment>
        ) : null}
        {details.details &&
        details.details.paymentDetails &&
        details.details.paymentDetails.length ? (
          <React.Fragment>
            <h3 style={{ fontWeight: 400, textDecoration: "underline" }}>
              Payment Details
            </h3>

            <Table celled fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>ID</Table.HeaderCell>
                  <Table.HeaderCell>Payment Gateway</Table.HeaderCell>
                  <Table.HeaderCell>Payment Gateway ID</Table.HeaderCell>
                  <Table.HeaderCell>Cart ID</Table.HeaderCell>
                  <Table.HeaderCell>Amount</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>Created On</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {details.details &&
                  details.details.paymentDetails &&
                  details.details.paymentDetails.length &&
                  details.details.paymentDetails.map((el) => (
                    <Table.Row key={el.paymentId}>
                      <Table.Cell style={{ wordWrap: "break-word" }}>
                        {el.paymentId}
                      </Table.Cell>
                      <Table.Cell>{el.paymentGateway}</Table.Cell>
                      <Table.Cell>{el.paymentGatewayId}</Table.Cell>
                      <Table.Cell>{el.paymentCartId}</Table.Cell>
                      <Table.Cell>Rs. {el.paymentAmount}</Table.Cell>
                      <Table.Cell>{el.paymentStatus}</Table.Cell>
                      <Table.Cell>
                        {moment
                          .utc(el.paymentCreatedOn)
                          .local()
                          .format("DD-MM-YYYY HH:mm:ss")}
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </React.Fragment>
        ) : null}
        {details.details &&
        details.details.sysTxn &&
        details.details.sysTxn.length ? (
          <React.Fragment>
            <h3 style={{ fontWeight: 400, textDecoration: "underline" }}>
              Transaction Details
            </h3>

            <Table celled fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Payee ID</Table.HeaderCell>
                  <Table.HeaderCell>Payer ID</Table.HeaderCell>
                  <Table.HeaderCell>Payment Gateway ID</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>Transaction Type</Table.HeaderCell>
                  <Table.HeaderCell>Created On</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {details.details &&
                  details.details.sysTxn &&
                  details.details.sysTxn.length &&
                  details.details.sysTxn.map((el) => (
                    <Table.Row key={el.id}>
                      <Table.Cell>{el.payee_id || "N/A"}</Table.Cell>
                      <Table.Cell>{el.payer_id || "N/A"}</Table.Cell>
                      <Table.Cell>{el.payment_gateway_id}</Table.Cell>
                      <Table.Cell>{el.txn_message}</Table.Cell>
                      <Table.Cell style={{ wordWrap: "break-word" }}>
                        {el.txn_type}
                      </Table.Cell>
                      <Table.Cell>
                        {moment
                          .utc(el.created_timestamp)
                          .local()
                          .format("DD-MM-YYYY HH:mm:ss")}
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </React.Fragment>
        ) : null}
      </Grid.Row>
    </Grid>
  );
};
export default OrderDetails;



// WEBPACK FOOTER //
// ./src/Modules/OrdersDetails/component.jsx